<template>
    <div class="view_single_application_solution_wrapper" v-if="solution" :key="id_solution">
        <header>
            <section class="top_navigation_view">
                <a class="button-previous-page" @click="goToSolutionsLists"><i class="shadow_box icon-chevron-left"><span>{{
                    translations.generic.return_list_solution
                }}</span></i></a>
                <comp_query_nav_options></comp_query_nav_options>
            </section>
            <h3 class="name_obra" v-if="this.solution">
                {{ this.solution.work[this.language] }}

                <!-- CONSULTA GUARDADA ?? -->
                <span v-if="App.query.current_query" class="current_query_name">
                    <span class="query_info_title">{{ '&#151;' }} {{ translations.generic.query }}</span>
                    {{ App.query.current_query.name }}</span>
            </h3>
        </header>

        <section class="solutions_wrapper" v-if="solution">
            <section>
                <!-- SLIDER  -->
                <div class="col1">
                    <section class="slider-solutions-images">
                        <button type="button" class="gallery_slider slick-prev slick-arrow" @click="$refs.slick.previous()">
                            Previous
                        </button>

                        <slick ref="slick" :options="slickOptions">
                            <img v-for="(image, index) in solution.images" :key="index" :src="App.apiUrl + image" alt="" />
                        </slick>

                        <button type="button" class="gallery_slider slick-next slick-arrow" @click="$refs.slick.next()">
                            Next
                        </button>
                    </section>
                </div>

                <!-- SOLUTION INFORMATION -->
                <div class="col2 solution-information" v-if="solution">
                    <header>
                        <div class="solution-image" v-if="solution.solution_image" :style="
                            'background-image: url(' +
                            App.apiUrl +
                            '/' +
                            solution.solution_image +
                            ')'
                        "></div>
                        <a @click="changeTabsInfo">
                            <img src="svg/info-circle.svg" v-if="is_information_tab_hide == true"
                                class="information-icon" />
                            <img src="svg/close-circle.svg" v-if="is_information_tab_hide == false"
                                class="information-icon" />
                        </a>
                        <img class="logo-icon" style="max-width:125px" src="img/logo_unex_negative.svg" alt="logo" />
                    </header>
                    <div v-if="is_information_tab_hide == false" class="panel_additional_information">
                        <span class="wrapper_data_response_field">
                            <label class="label">
                                {{
                                    translations.single_solution_view.learn_more
                                }}
                            </label>
                            <p class="additional_information" v-if="solution.additional_information">
                                {{ solution.additional_information[language] }}
                            </p>
                        </span>
                    </div>

                    <div v-if="is_information_tab_hide == true" class="panel_value_fields_solution">
                        <!-- AÑO  -->
                        <span class="wrapper_data_response_field">
                            <label class="label">{{
                                translations.single_solution_view.year
                            }}</label>
                            <p class="year" v-if="solution.year">
                                {{ solution.year | yearfilter }}
                            </p>
                        </span>

                        <!-- OBRA  -->
                        <span class="wrapper_data_response_field" v-if="solution.work">
                            <label class="label">{{ translations.single_solution_view.work }}</label>
                            <p class="work">
                                {{ solution.work[language] }}
                            </p>
                        </span>

                        <!-- CIUDAD-PAIS -->
                        <span class="wrapper_data_response_field">
                            <label class="label">{{ translations.single_solution_view.location }}</label>
                            <p class="country">
                                <span>{{ cityCalculation }}</span>
                            </p>
                        </span>

                        <!-- APLICACIONES -->
                        <span class="wrapper_data_response_field">
                            <label class="label">{{ translations.single_solution_view.application }}</label>
                            <p class="application">
                                {{ App.entities.applications[solution.application][current_language] }}
                            </p>
                        </span>

                        <!-- TEMAS -->
                        <span class="wrapper_data_response_field" v-if="solution.themes">
                            <label class="label">{{ translations.single_solution_view.themes }}</label>
                            <p class="themes" v-for="(theme, index) in solution.themes" :key="index">
                                {{ theme }}
                            </p>
                        </span>

                        <!-- PRODUCTS -->
                        <span class="wrapper_data_response_field">
                            <label class="label">{{ translations.single_solution_view.products }}</label>
                            <p class="products" v-for="(product, index) in solution.products" :key="index">
                                <span>{{ App.entities.product_families[product[0]][language] }}</span>
                                <span> - {{ App.entities.materials[product[1]][language] }}</span>
                            </p>
                        </span>
                    </div>
                </div>
            </section>

            <footer :disabled="App.query.active_search.length == 0">
                <a @click="prevWork">
                    <i class="icon-arrow-left"></i>
                </a>
                <p>
                    <!-- Current Id: {{ id_solution }}
                    Index: {{ App.query.indexForSolutionId(id_solution) }}
                    Next solution Id: {{ App.query.nextSolutionId(id_solution) }} -->
                    {{ App.query.indexForSolutionId(id_solution) + 1 }}
                    <span>{{ translations.generic.of }}</span> {{ App.query.active_search.length }}
                    <span class="results_application">{{
                        translations.generic.results
                    }}</span>
                </p>
                <a @click="nextWork">
                    <i class="icon-arrow-right"></i>
                </a>
            </footer>
        </section>
        <div class="wrapper_slider_sync">
            <section class="slider_container">
                <button type="button" class="sync_slider slick-prev slick-arrow">
                    Previous
                </button>
                <div class="sync slider"></div>
                <button type="button" class="sync_slider slick-next slick-arrow">
                    Next
                </button>
                <a class="btn-close" @click="closeSlider()"></a>
            </section>
        </div>
    </div>
</template>

<script>
import $ from 'jquery'
import App from './../application.js'
import comp_query_nav_options from './comp_query_nav_options.vue'
import Slick from 'vue-slick'

export default {
    components: {
        comp_query_nav_options,
        Slick
    },
    data: function () {
        return {
            App: App,
            // Current solution
            id_solution: App.id_selected_solution,
            solution: null,
            slickOptions: {
                arrows: false
                // Any other options that can be got from plugin documentation
            },
            is_information_tab_hide: true,

            language: App.selected_language,
            markets: App.entities.markets,

            current_language: App.selected_language,
            translations: App.current_translations,
        }

    },
    methods: {
        async loadSolution(id) {
            // Load current solution
            this.solution = await App.query.getSolution(id)
            document.title = "UnexApp - " + this.solution.work[this.language]

            // debug
            // console.warn(this.solution)
        },

        nextWork: function () {
            var next_id = App.query.nextSolutionId(this.id_solution)
            if (next_id) {
                this.$router.push('/solutions/' + next_id);
                this.id_solution = next_id
                App.id_selected_solution = next_id
                // this.loadSolution(next_id);
            }
        },
        prevWork: function () {
            var prev_id = App.query.prevSolutionId(this.id_solution)
            if (prev_id) {
                this.$router.push('/solutions/' + prev_id);
                this.id_solution = prev_id
                App.id_selected_solution = prev_id
                // this.loadSolution(prev_id);
            }
        },

        goToSolutionsLists: function () {
            // App.root_activated_view = 'application_solutions';
            this.$router.push('/solutions')
        },
        changeTabsInfo: function () {
            this.is_information_tab_hide = this.is_information_tab_hide != true;
        },
        showSlider: function (image) {
            this.wrapper_slider = true;
            $(".wrapper_slider_sync").css('top', '0');
            $(".wrapper_slider_sync .sync img").css('margin', '0 auto');
        },
        closeSlider: function () {
            $(".wrapper_slider_sync").css('top', '-200vh');
            this.wrapper_slider = false;
        },


    },
    mounted: async function () {
        await this.loadSolution(App.id_selected_solution)

        return;
    },
    watch: {
        async $route(to, from) {
            await this.loadSolution(to.params.idsolution)
        }
    },
    filters: {
        yearfilter: function (value) {
            value = value.toString();
            if (value.length === 4) return value;
            else return value.substr(0, 4);
        }
    },
    computed: {
        cityCalculation: function () {
            if (!this.solution) return '';

            var selected_market = parseInt(App.selected_market_solutions);
            var markets = [0, 65, 72, 54, 175, -1, 105, 44];

            var city = this.solution.city[this.language]
                .capitalize().trim();
            var province = App.entities.provinces[
                this.solution.province
            ][
                this.current_language
            ]
                .capitalize().trim();
            var country = App.entities.countries[
                this.solution.country
            ][
                this.current_language
            ]
                .capitalize().trim();

            if (parseInt(this.solution.country) === markets[selected_market]) {
                //Show Province, City
                if (city === province) return city;
                else {
                    if (city == "" || city == "-") return province;
                    if (province == "" || province == "-") return city;

                    return [city, province].join(", ");
                }
            } else {
                //Show Country, City
                if (country === city) return country;
                else {
                    if (city == "" || city == "-") return country;
                    if (country == "" || country == "-") return city;
                    return [city, country].join(", ");
                }
            }
        }
    },
    updated: function () {
    }
}
</script>

<style></style>